import { getMonitoringGraphActionType, getMonitoringPathActionType, MonitoringGraphActionTypes, updateMonitoringGraphActionType, 
  updateMonitoringPathActionType, getEventsActionType, 
} from '../../model/monitoringGraph/actions';
import { Graph, Event, MonitoringGraphOptions, MonitoringPathOptions } from '../../model/monitoringGraph/types';
import { createActions } from '../../helpers/actionsHelper';

export const getMonitoringGraphAction = createActions<MonitoringGraphActionTypes, MonitoringGraphOptions, Graph>(getMonitoringGraphActionType);

export const getMonitoringPathAction = createActions<MonitoringGraphActionTypes,MonitoringPathOptions, Graph>(getMonitoringPathActionType);

export const updateMonitoringGraphAction = createActions<MonitoringGraphActionTypes,{},Graph>(updateMonitoringGraphActionType)

export const updateMonitoringPathAction = createActions<MonitoringGraphActionTypes,{},Graph>(updateMonitoringPathActionType)

export const getEventsAction= createActions<MonitoringGraphActionTypes,null,Event>(getEventsActionType);